<template>
  <div>
    <v-chip v-if="report.cas_assessed" label small>
      <v-avatar left small class="d-none d-lg-inline-block">
        <v-icon small> mdi-magnify </v-icon>
      </v-avatar>
      Beoordeeld CD
    </v-chip>

    <v-chip v-if="report.cas_admitted" label small class="ma-2">
      <v-avatar left small class="d-none d-lg-inline-block">
        <v-icon small color="black"> mdi-hospital-box-outline </v-icon>
      </v-avatar>
      Opgenomen CD
    </v-chip>

    <v-chip
      v-if="report.dangerous"
      label
      small
      class="ma-2"
      color="red"
      text-color="white"
    >
      <v-avatar left small class="d-none d-lg-inline-block">
        <v-icon small color="white"> mdi-alert </v-icon>
      </v-avatar>
      Gevaarlijk
    </v-chip>
  </div>
</template>

<script>
export default {
  name: "ReportStatus",
  props: ["report"],
};
</script>
